import React from 'react';
import { useSelector } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import clsx from 'clsx';
// material ui
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import MobileStepper from '@material-ui/core/MobileStepper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
// components
import WidgetBar from '../../../../builder/components/WidgetBar.js'
import Theme from '../../Theme.js';
// helpers
import { getTabsContext } from '../helpers.js'
import { translate } from '../translations'

const useStyles = makeStyles({
  '@keyframes backgroundPulsate': {
    '0%': {
      background: 'hsla(231, 48%, 48%, .25)',
    },
    '50%': {
      background: 'hsla(231, 48%, 48%, .05)',
    },
    '100%': {
      background: 'hsla(231, 48%, 48%, .25)',
    },
  },
  activeGroup: {
    animation: '$backgroundPulsate 2s infinite',
    // background: 'hsla(231, 48%, 48%, .15)',
  },
  avatar: {
    width: '100%',
    height: '100%',
    '& img': {
      borderRadius: '50%',
      width: '56px',
      height: '56px',
      padding: '2px',
      border: '2px solid ' + Theme.palette.primary.main,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)',
    },
  },
  avatarContainer: {
    paddingBottom: '10px',
    position: 'relative',
  },
  card: {
    marginBottom: '28px',
    boxShadow: Theme.cardBoxShadow,
    position: 'relative',
  },
  cardMobile: {
    boxShadow: 'none',
    borderRadius: '0px',
    marginBottom: '10px',
    backgroundColor: '#ffffff',
  },
  collapsed: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.18)',
    borderTop: '1px solid rgba(0, 0, 0, 0.18)',
    height: '25px',
    margin: '4px 0',
    textAlign: 'center',
    '& > span': {
      display: 'inline-block',
      fontSize: '20px',
      letterSpacing: '4px',
      lineHeight: '25px',
      transform: 'translateY(-5px)',
    }
  },
  header: {
    backgroundColor: props => props.screen == 'desktop' ? Theme.bgColorDark : '#ffffff',
    textAlign: 'center',
  },
  headerText: {
      padding: '16px 16px 8px',
      textAlign: 'center',
  },
  lbText: {
    color: Theme.palette.text.secondary,
  },
  lbTypeHeader: {
    display: 'flex',
    '& > div': {
      color: Theme.palette.text.secondary,
      flex: '1',
      fontFamily: Theme.typography.fontFamily,
      fontSize: '.75rem',
      textAlign: 'center',
      textTransform: 'uppercase',
    },
  },
  list: {
    width: '100%',
  },
  middle: {
    flex: '1 1 auto',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingLeft: '8px',
    paddingRight: '5px',
    '& .name': {
      minWidth: 0,
      fontSize: '13px',
      lineHeight: 1,
    },
    '& .date': {
      fontSize: '13px',
      lineHeight: 1,
      color: Theme.palette.text.secondary,
      marginTop: '5px',
    },
  },
  rank: {
    position: 'absolute',
    bottom: '0px',
    left: '15.5px',
    fontSize: '10px',
    width: '25px',
    lineHeight: '15px',
    backgroundColor: Theme.palette.primary.main,
    textAlign: 'center',
    color: Theme.bgColorLight,
    borderRadius: '3px',
    border: '2px solid ' + Theme.bgColorLight,
  },
  right: {
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .time': {
      fontSize: '1.3rem',
      lineHeight: 1,
    },
    '& .time-label': {
      color: Theme.palette.text.secondary,
      fontSize: '.6rem',
      letterSpacing: '.02em',
      lineHeight: 1,
      marginTop: '5px',
      textTransform: 'uppercase',
    },
  },
  roomText: {
    fontSize: '1.3rem',
  },
  tabRoot: {
    minWidth: '25%',
    padding: '6px 0',
  },
  // multi
  dotsContainer: {
    position: 'absolute',
    top: props => props.dotsTop,
  },
  headerMulti: {
    backgroundColor: props => props.screen == 'desktop' ? Theme.bgColorDark : '#ffffff',
    padding: '1rem 0 0',
    textAlign: 'center',
    '& .arrows': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      '&:hover': {
        cursor: 'pointer',
        opacity: '.8',
      },
    },
    '& .leftArrow': {
      left: '1rem',
    },
    '& .rightArrow': {
      right: '1rem',
    },
  },
  multiLbContainer: {
    position: 'relative',
    '& .arrows': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      '&:hover': {
        cursor: 'pointer',
        opacity: '.8',
      },
    },
    '& .leftArrow': {
      left: '1rem',
    },
    '& .rightArrow': {
      right: '1rem',
    },
  },
  multiLbStepper: {
    background: 'transparent',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: '0',
    '& .arrows': {
      borderRadius: '50%',
      minWidth: '0px',
      position: 'absolute',
      top: '45px',
      // '&:hover': {
      //   cursor: 'pointer',
      //   opacity: '.8',
      // },
    },
    '& .leftArrow': {
      left: '1rem',
    },
    '& .rightArrow': {
      right: '1rem',
    },
  },
});

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function LeaderboardList(props) {
  const classes = useStyles();
  const { language, lbType, value, index, context, rankingValueLabel, rankingValue, ...other } = props

  const LbList = context['leaderboards'][lbType + '_list']
  const LbRanking = context['leaderboards'][lbType + '_ranking']
  const currentGroup = context.leaderboards.current_group

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <List className="lb-list">
        {LbList.length > 0 ? (
          LbList.slice(0, context.length).map( (item, index) =>
            <ListItem key={index} className={item.id === currentGroup.id ? classes.activeGroup : null}>
              <Box className={classes.avatarContainer} >
                <ListItemAvatar >
                    <Avatar src={item.photo} className={classes.avatar} />
                </ListItemAvatar>
                  <div className={classes.rank} >#{index + 1}</div>
              </Box>
              <Box className={classes.middle}>
                <Typography variant="subtitle2" component="span" className="name">
                  {item.group_name}
                </Typography>
                <Typography variant="body2" component="p" className="date">
                  {item.date}
                </Typography>
              </Box>
              <Box className={classes.right}>
                <Typography variant="body1" component="span" className="time">
                  { item[rankingValue] || item[rankingValue] === 0
                    ? ( rankingValue == "points" ? (
                        item[rankingValue].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                      ) : (
                        item[rankingValue]
                      )
                    ) : (
                      "n/a"
                    )
                  }
                </Typography>
                <Typography variant="caption" component="p" className="time-label">
                  { rankingValueLabel }
                </Typography>
              </Box>
            </ListItem>
          )
        ) : (
          <ListItem >
            <ListItemText style={{ textAlign: 'center' }}
              primary={translate("Nothing to see here...", language)}
              secondary={translate("There are no entries on this leaderboard.", language)}
            />
          </ListItem>
        )}

        {context.show_current_group && (
          <>
          {LbRanking && (LbRanking > (context.length + 1)) &&
            <div className={classes.collapsed}><span>...</span></div>
          }
          {LbRanking && (LbRanking > context.length) &&
            <ListItem className={classes.activeGroup}>
              <Box className={classes.avatarContainer} >
                <ListItemAvatar >
                    <Avatar src={currentGroup.photo} className={classes.avatar} />
                </ListItemAvatar>
                  <div className={classes.rank} >#{LbRanking}</div>
              </Box>
              <Box className={classes.middle}>
                <Typography variant="subtitle2" component="span" className="name">
                  {currentGroup.group_name}
                </Typography>
                <Typography variant="body2" component="p" className="date">
                  {currentGroup.date}
                </Typography>
              </Box>
              <Box className={classes.right}>
                <Typography variant="body1" component="span" className="time">
                  { currentGroup[rankingValue] || currentGroup[rankingValue] === 0
                    ? ( rankingValue == "points" ? (
                      currentGroup[rankingValue].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                      ) : (
                        currentGroup[rankingValue]
                      )
                    ) : (
                      "n/a"
                    )
                  }
                </Typography>
                <Typography variant="caption" component="p" className="time-label">
                  { rankingValueLabel }
                </Typography>
              </Box>
            </ListItem>
          }
          </>
        )}
        
      </List>
    </Box>
  )
}

function MultiLeaderboardList(props) {
  const classes = useStyles();
  const { language, value, index, context, rankingMetric, rankingValueLabel, length } = props

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
    >
      <List className="lb-list">
        {context.length > 0 ? (
          context.slice(0, length).map( (item, index) =>
            <ListItem key={index} >
              <Box className={classes.avatarContainer} >
                <ListItemAvatar >
                    <Avatar src={item.photo} className={classes.avatar} />
                </ListItemAvatar>
                  <div className={classes.rank} >#{index + 1}</div>
              </Box>
              <Box className={classes.middle}>
                <Typography variant="subtitle2" component="span" className="name">
                  {item.group_name}
                </Typography>
                <Typography variant="body2" component="p" className="date">
                  {item.date}
                </Typography>
              </Box>
              <Box className={classes.right}>
                <Typography variant="body1" component="span" className="time">

                  {rankingMetric == "Time Remaining" ? (
                    item.time_remaining ? item.time_remaining : "n/a"
                  ) : null }

                  {rankingMetric == "Points" ? (
                    item.points ? item.points.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : "n/a"
                  ) : null }

                  {rankingMetric == "Clues" ? (
                    item.clues ? item.clues : "n/a"
                  ) : null }

                </Typography>
                <Typography variant="caption" component="p" className="time-label">
                  { rankingValueLabel }
                </Typography>
              </Box>
            </ListItem>
          )
        ) : (
          <ListItem >
            <ListItemText style={{ textAlign: 'center' }}
              primary={translate("Nothing to see here...", language)}
              secondary={translate("There are no entries on this leaderboard.", language)}
            />
          </ListItem>
        )}
      </List>
    </Box>
  )
}

export default function Leaderboard(props) {
  const { context, screen } = props;
  let groupType;
  let language;
  if (window.mode == 'live') {
    groupType = window.groupType;
    language = window.language;
  } else {
    groupType = useSelector(state => state.groupType)
    language = useSelector(state => state.language)
  };
  
  return (
    <>
    {groupType == 'single' ? (
      <SingleLeaderboard context={context} language={language} screen={screen} />
      ) : (
      <MultiLeaderboard context={context} language={language} screen={screen} />
    )}
    </>
  );
}

function MultiLeaderboard(props) {
  const { context, language, screen } = props;
  // local state
  const [showWidgetBar, setShowWidgetBar] = React.useState(false)
  const [roomValue, setRoomValue] = React.useState(0);
  const [lbValue, setLbValue] = React.useState(context.show_initial);

  const tabsContext = getTabsContext([
    context.show_all_groups_all_time,
    context.show_all_groups_last_30_days,
    context.show_by_group_size_all_time,
    context.show_by_group_size_last_30_days,
  ], context.group_size, language)

  const dotsTopBase = 75;
  const dotsTopExtraText = tabsContext.lb_label.show ? 19 : 0;
  const dotsTop = dotsTopBase + dotsTopExtraText + 'px';

  const classes = useStyles({ screen, dotsTop });
  const componentClasses = clsx({
    [classes.card] : true,
    [classes.cardMobile] : screen == 'mobile' ? true : false,
  })

  function handleLbChange(event, newValue) {
    setLbValue(newValue);
  }

  function handleLbChangeIndex(index) {
    setLbValue(index);
  }

  const maxLbIndex = context.event_leaderboards.length - 1;
  function handleRoomChange(newValue) {
    if (newValue < 0) {
      setRoomValue(maxLbIndex);
    } else if (newValue > maxLbIndex) {
      setRoomValue(0);
    } else {
      setRoomValue(newValue);
    }
  }

  function handleRoomChangeIndex(index) {
    setRoomValue(index);
  }

  const handleWidgetHover = (e) => {
    if (e.type == 'mouseenter') {
      setShowWidgetBar(true);
    } else if (e.type == 'mouseleave') {
      setShowWidgetBar(false);
    }
  }

  
  return (
    <div className={classes.multiLbContainer + ' event-leaderboard-widget'}
      onMouseEnter={window.mode == 'builder' ? handleWidgetHover : null} onMouseLeave={window.mode == 'builder' ? handleWidgetHover : null}
    >
      <SwipeableViews
        index={roomValue}
        onChangeIndex={handleRoomChangeIndex}
      >
        {context.event_leaderboards.map( (item, index) =>
        <Card key={item.room_name} className={componentClasses} >
          <CardContent className={classes.headerMulti} >
            <div style={{ marginBottom: '24px' }} >
              <Typography variant="body1" component="span" className={classes.roomText} >
                {item.room_name}
              </Typography>
              <Typography variant="caption" component="p" className={classes.lbText}>
                {translate('leaderboard', language).toUpperCase()}
              </Typography>
              {tabsContext.lb_label.show &&
                <Typography variant="caption" component="p" className={classes.lbText}>
                  {tabsContext.lb_label.text}
                </Typography>
              }
            </div>
            {tabsContext.headers.show &&
              <div className={classes.lbTypeHeader} >
                <div>{tabsContext.headers.all_groups_label}</div>
                <div>{tabsContext.headers.by_size_label}</div>
              </div>
            }
            {tabsContext.tabs_show &&
              <Tabs
                value={lbValue}
                onChange={handleLbChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
              >
                {context.show_all_groups_all_time &&
                  <Tab value={0} disableRipple {...a11yProps(0)}
                    label={tabsContext.all_groups_all_time.label}
                    classes={{root: classes.tabRoot}}
                    style={{
                      flex: tabsContext.all_groups_all_time.flex,
                      fontSize: tabsContext.tabs_font_size,
                    }}
                  />
                }
                {context.show_all_groups_last_30_days &&
                  <Tab value={1} disableRipple {...a11yProps(1)}
                    label={tabsContext.all_groups_last_30_days.label}
                    classes={{root: classes.tabRoot}}
                    style={{
                      flex: tabsContext.all_groups_last_30_days.flex,
                      fontSize: tabsContext.tabs_font_size,
                    }}
                  />
                }
                {context.show_by_group_size_all_time &&
                  <Tab value={2} disableRipple {...a11yProps(2)}
                    label={tabsContext.by_group_size_all_time.label}
                    classes={{root: classes.tabRoot}}
                    style={{
                      flex: tabsContext.by_group_size_all_time.flex,
                      fontSize: tabsContext.tabs_font_size,
                    }}
                  />
                }
                {context.show_by_group_size_last_30_days &&
                  <Tab value={3} label="Last 30 Days" disableRipple {...a11yProps(3)}
                    label={tabsContext.by_group_size_last_30_days.label}
                    classes={{root: classes.tabRoot}}
                    style={{
                      flex: tabsContext.by_group_size_last_30_days.flex,
                      fontSize: tabsContext.tabs_font_size,
                    }}
                  />
                }
              </Tabs>
            }
          </CardContent>

          <SwipeableViews
            // axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={lbValue}
            onChangeIndex={handleLbChangeIndex}
          >
            {context.show_all_groups_all_time &&
              <MultiLeaderboardList language={language} value={lbValue} index={0} context={item.all_groups_all_time_list} rankingMetric={item.ranking_metric} rankingValueLabel={item.ranking_value_label} length={context.length} />
            }
            {context.show_all_groups_last_30_days &&
              <MultiLeaderboardList language={language} value={lbValue} index={1} context={item.all_groups_last_30_days_list} rankingMetric={item.ranking_metric} rankingValueLabel={item.ranking_value_label} length={context.length} />
            }
            {context.show_by_group_size_all_time &&
              <MultiLeaderboardList language={language} value={lbValue} index={2} context={item.by_size_all_time_list} rankingMetric={item.ranking_metric} rankingValueLabel={item.ranking_value_label} length={context.length} />
            }
            {context.show_by_group_size_last_30_days &&
              <MultiLeaderboardList language={language} value={lbValue} index={3} context={item.by_size_last_30_days_list} rankingMetric={item.ranking_metric} rankingValueLabel={item.ranking_value_label} length={context.length} />
            }
          </SwipeableViews>
          
        </Card>
        )}
        
      </SwipeableViews>

      {window.mode == 'builder' && showWidgetBar &&
        <WidgetBar context={context} />
      }

      <MobileStepper
        classes={{ dots: classes.dotsContainer }}
        variant="dots"
        steps={maxLbIndex + 1}
        position="top"
        activeStep={roomValue}
        className={classes.multiLbStepper}
        nextButton={
          <Button className="arrows rightArrow" onClick={() => handleRoomChange(roomValue+1)} disabled={roomValue === maxLbIndex}>
            <ChevronRightIcon />
          </Button>
        }
        backButton={
          <Button className="arrows leftArrow" onClick={() => handleRoomChange(roomValue-1)} disabled={roomValue === 0}>
            <ChevronLeftIcon />
          </Button>
        }
      />

    </div>

  );
}

function SingleLeaderboard(props) {
  const { context, language, screen } = props;
  // local state
  const [showWidgetBar, setShowWidgetBar] = React.useState(false)
  const [value, setValue] = React.useState(context.show_initial);
  const classes = useStyles(props);
  const theme = useTheme();
  const componentClasses = clsx({
    [classes.card] : true,
    "cardMobile" : screen == 'mobile' ? true : false,
  })

  var rankingValueLabel;
  var rankingValue;
  var roomName;
  if (window.mode == 'live') {
    if (["TIME_REMAINING", "Time Remaining"].includes(context.ranking_metric)) {
      rankingValue = "time_remaining";
    } else if (["POINTS", "Points"].includes(context.ranking_metric)) {
      rankingValue = "points";
    } else if (["Clues"].includes(context.ranking_metric)) {
      rankingValue = "clues";
    }
    rankingValueLabel = context.ranking_value_label;
    roomName = context.room_name;
  } else {
    var activeRoom = useSelector(state => state.activeRoom);
    var lbSettings = useSelector(state => state.lbSettings);
    if (["TIME_REMAINING", "Time Remaining"].includes(lbSettings[activeRoom]["ranking_metric"])) {
      rankingValue = "time_remaining";
    } else if (["POINTS", "Points"].includes(lbSettings[activeRoom]["ranking_metric"])) {
      rankingValue = "points";
    } else if (["Clues"].includes(lbSettings[activeRoom]["ranking_metric"])) {
      rankingValue = "clues";
    }
    rankingValueLabel = lbSettings[activeRoom]["ranking_value_label"][language];
    roomName = lbSettings[activeRoom]["room_name"];
  }

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  function handleChangeIndex(index) {
    setValue(index);
  }

  const handleWidgetHover = (e) => {
    if (e.type == 'mouseenter') {
      setShowWidgetBar(true);
    } else if (e.type == 'mouseleave') {
      setShowWidgetBar(false);
    }
  }

  const tabsContext = getTabsContext([
    context.show_all_groups_all_time,
    context.show_all_groups_last_30_days,
    context.show_by_group_size_all_time,
    context.show_by_group_size_last_30_days,
  ], context.group_size, language)

  return (
    <Card className={componentClasses + ' leaderboard-widget'}
      onMouseEnter={window.mode == 'builder' ? handleWidgetHover : null} onMouseLeave={window.mode == 'builder' ? handleWidgetHover : null}
    >
      <Box className={classes.header}>
        <Box className={classes.headerText}>
          <Typography variant="body1" component="span" className={classes.roomText} >
            {roomName}
          </Typography>
          <Typography variant="caption" component="p" className={classes.lbText}>
            {translate('leaderboard', language).toUpperCase()}
          </Typography>
          {tabsContext.lb_label.show &&
            <Typography variant="caption" component="p" className={classes.lbText}>
              {tabsContext.lb_label.text}
            </Typography>
          }
        </Box>
        {tabsContext.headers.show &&
          <div className={classes.lbTypeHeader} >
            <div>{tabsContext.headers.all_groups_label}</div>
            <div>{tabsContext.headers.by_size_label}</div>
          </div>
        }
        {tabsContext.tabs_show &&
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            {context.show_all_groups_all_time &&
              <Tab value={0} disableRipple {...a11yProps(0)}
                label={tabsContext.all_groups_all_time.label}
                classes={{root: classes.tabRoot}}
                style={{
                  flex: tabsContext.all_groups_all_time.flex,
                  fontSize: tabsContext.tabs_font_size,
                }}
              />
            }
            {context.show_all_groups_last_30_days &&
              <Tab value={1} disableRipple {...a11yProps(1)}
                label={tabsContext.all_groups_last_30_days.label}
                classes={{root: classes.tabRoot}}
                style={{
                  flex: tabsContext.all_groups_last_30_days.flex,
                  fontSize: tabsContext.tabs_font_size,
                }}
              />
            }
            {context.show_by_group_size_all_time &&
              <Tab value={2} disableRipple {...a11yProps(2)}
                label={tabsContext.by_group_size_all_time.label}
                classes={{root: classes.tabRoot}}
                style={{
                  flex: tabsContext.by_group_size_all_time.flex,
                  fontSize: tabsContext.tabs_font_size,
                }}
              />
            }
            {context.show_by_group_size_last_30_days &&
              <Tab value={3} label="Last 30 Days" disableRipple {...a11yProps(3)}
                label={tabsContext.by_group_size_last_30_days.label}
                classes={{root: classes.tabRoot}}
                style={{
                  flex: tabsContext.by_group_size_last_30_days.flex,
                  fontSize: tabsContext.tabs_font_size,
                }}
              />
            }
          </Tabs>
        }
      </Box>

      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {context.show_all_groups_all_time &&
          <LeaderboardList language={language} value={value} index={0} context={context} lbType="all_groups_all_time" rankingValueLabel={rankingValueLabel} rankingValue={rankingValue} />
        }
        {context.show_all_groups_last_30_days &&
          <LeaderboardList language={language} value={value} index={1} context={context} lbType="all_groups_last_30_days" rankingValueLabel={rankingValueLabel} rankingValue={rankingValue} />
        }
        {context.show_by_group_size_all_time &&
          <LeaderboardList language={language} value={value} index={2} context={context} lbType="by_size_all_time" rankingValueLabel={rankingValueLabel} rankingValue={rankingValue} />
        }
        {context.show_by_group_size_last_30_days &&
          <LeaderboardList language={language} value={value} index={3} context={context} lbType="by_size_last_30_days" rankingValueLabel={rankingValueLabel} rankingValue={rankingValue} />
        }
      </SwipeableViews>

      {window.mode == 'builder' && showWidgetBar &&
        <WidgetBar context={context} />
      }

    </Card>
  );
}

